import { compact } from 'lodash';

import { EntityDetail_EntityFragment } from '@/modules/entities/details/graphql/EntityDetailPage.generated';
import { getEntityTypeFromEntityKind } from '@/modules/entities/utils/getEntityTypeFromEntityKind';
import { getNonTrustCharitableEntitySummaryProperties } from '@/modules/nonTrustCharitableEntities/NonTrustCharitableEntityDetails/NonTrustCharitableEntityDetails.utils';
import { EntityKind } from '@/types/schema';

import {
  EntityCoverSlideData,
  EntityCoverSlideDetailsList,
} from './EntityCoverSlide.types';
import { EntityCoverSlideDataPoint } from './EntityCoverSlide.types';
import {
  dataPointGetters,
  detailsListGetters,
  getTotalDeathBenefit,
} from './EntityCoverSlide.utils';

export function getNonTrustCharitableEntityDetails(
  entity: EntityDetail_EntityFragment,
  entityKind: EntityKind.DonorAdvisedFund | EntityKind.PrivateFoundation
): Omit<EntityCoverSlideData, 'title'> {
  const summary =
    getNonTrustCharitableEntitySummaryProperties({
      entity,
      entityType: getEntityTypeFromEntityKind(entityKind),
    }) || null;

  if (!summary) {
    return {
      dataPoints: [],
      detailsLists: [],
    };
  }

  const dataPoints: EntityCoverSlideDataPoint[] = compact([
    dataPointGetters.getTotalMarketValueDataPoint(entity),
    dataPointGetters.getAssetLocationDataPoint(summary),
    dataPointGetters.getNamesDataPoint(summary),
    dataPointGetters.getTaxStatusDataPoint(summary),
    dataPointGetters.getEffectiveDateDataPoint(summary),
  ]);
  const detailsLists: EntityCoverSlideDetailsList[] = compact([
    detailsListGetters.getControllingPersons(summary),
  ]);

  return {
    dataPoints,
    detailsLists,
    totalDeathBenefit: getTotalDeathBenefit(summary),
  };
}
